import { useCallback } from 'react';
import { useModal } from '@/contexts/ModalContext';
import { PaywallModal } from '~/purchases/components/paywall-modal/PaywallModal';

/**
 * Opens the generic promotional paywall (see {@link PaywallModal}) via the root
 * modal system. Use directly when an action should always upsell (e.g. a drained
 * AI wallet), or through {@link useFeatureGuard} to gate a specific
 * {@link import('@fytness/shared').Feature}.
 */
export const usePaywall = () => {
  const { showModal } = useModal();
  const openPaywall = useCallback(() => {
    showModal(PaywallModal);
  }, [showModal]);
  return { openPaywall };
};
